import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SiteContextService } from '@/app/shared/util-user/site-context.service';
import { environment } from '@/environments/environment';

@Injectable()
export class SiteContextInterceptor implements HttpInterceptor {
  private readonly siteContextService = inject(SiteContextService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !req.url.startsWith(environment.apiConfig.resources.brd.api) &&
      !req.url.startsWith(environment.apiConfig.resources.swd.api) &&
      !req.url.startsWith(environment.apiConfig.resources.di.api)
    )
      return next.handle(req);

    const siteIdFromUrl = this.siteContextService.getSiteIdFromUrl();
    if (!siteIdFromUrl) return next.handle(req);

    req = req.clone({
      setParams: {
        siteId: siteIdFromUrl,
      },
    });
    return next.handle(req);
  }
}
